// {
//   "name": "iconic-key-features-fourth.js",
//   "author": "Arham Web Works",
//   "description": "Copying in any form is strictly prohibited. Any instance of copying will be subject to legal action and accountability under the law."
// }

(() => {
  if (customElements.get("iconic-key-features-fourth")) return;

  class IconicKeyFeaturesFourth extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      setTimeout(() => this.initScripts(), 300);
    }

    initScripts() {
      this.loadSDKs();
      this.initCardEffects(this);
    }

    loadSDKs() {
      if (this.querySelector('iframe[data-video-type="youtube"]') && !window.YT) {
        if (!document.querySelector('script[src="https://www.youtube.com/iframe_api"]')) {
          const ytScript = document.createElement("script");
          ytScript.src = "https://www.youtube.com/iframe_api";
          document.head.appendChild(ytScript);
        }
      }

      if (this.querySelector('iframe[data-video-type="vimeo"]') && !window.Vimeo) {
        if (!document.querySelector('script[src="https://player.vimeo.com/api/player.js"]')) {
          const vimeoScript = document.createElement("script");
          vimeoScript.src = "https://player.vimeo.com/api/player.js";
          document.head.appendChild(vimeoScript);
        }
      }
    }

    initCardEffects(scope = document) {
      const cards = scope.querySelectorAll(".iconic-video-hover");
      cards.forEach((card) => {
        if (card.dataset.effectInitialized) return;
        card.dataset.effectInitialized = "true";

        this.initVideoControl(card);
      });
    }

    initVideoControl(card) {
      const video = card.querySelector("video");
      const iframe = card.querySelector("iframe");
      const hover = card.dataset.playOnHover === "true";

      if (video) {
        if (hover) {
          card.addEventListener("mouseenter", () => { video.currentTime = 0; video.play().catch(() => {}); });
          card.addEventListener("mouseleave", () => { video.pause(); video.currentTime = 0; });
        } else {
          card.addEventListener("click", () => video.paused ? video.play() : video.pause());
        }
      }

      if (!iframe) return;

      const type = iframe.dataset.videoType;
      const initYT = () => {
        if (!card._ytPlayer) card._ytPlayer = new YT.Player(iframe);
        const player = card._ytPlayer;
        if (hover) {
          card.addEventListener("mouseenter", () => player.playVideo());
          card.addEventListener("mouseleave", () => player.pauseVideo());
        } else {
          card.addEventListener("click", () => {
            player.getPlayerState() === 1 ? player.pauseVideo() : player.playVideo();
          });
        }
      };

      const initVimeo = () => {
        if (!card._vimeoPlayer) card._vimeoPlayer = new Vimeo.Player(iframe);
        const player = card._vimeoPlayer;
        if (hover) {
          card.addEventListener("mouseenter", () => player.play());
          card.addEventListener("mouseleave", () => player.pause());
        } else {
          card.addEventListener("click", () => player.getPaused().then(p => p ? player.play() : player.pause()));
        }
      };

      if (type === "youtube") {
        if (window.YT && window.YT.Player) initYT();
        else {
          window.onYouTubeIframeAPIReadyClick = initYT;
          const originalReady = window.onYouTubeIframeAPIReady;
          window.onYouTubeIframeAPIReady = () => { if (originalReady) originalReady(); if (window.onYouTubeIframeAPIReadyClick) window.onYouTubeIframeAPIReadyClick(); }
        }
      }

      if (type === "vimeo") {
        if (window.Vimeo && window.Vimeo.Player) initVimeo();
        else {
          const tag = document.createElement("script");
          tag.src = "https://player.vimeo.com/api/player.js";
          tag.onload = initVimeo;
          document.head.appendChild(tag);
        }
      }
    }
  }

  customElements.define("iconic-key-features-fourth", IconicKeyFeaturesFourth);

  ["shopify:section:load", "shopify:section:select", "shopify:block:select"].forEach(event => {
    document.addEventListener(event, e => {
      const section = e.target.closest("iconic-key-features-fourth") || e.target.querySelector("iconic-key-features-fourth");
      if (section) section.initCardEffects(section);
    });
  });

})();

